<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            v-if="exibirTicket"
            id="valorFaturamentoCliente"
            class="text-center"
          >
            {{ ticketMedio }}
          </div>
          <div
            v-if="exibirTicket"
            id="valorFaturamentoClienteAnterior"
            class="text-center"
          >
            {{ quantidadeVendas }} vendas
          </div>
          <div
            v-if="exibirTicket"
            id="valorTicketMedioPerfomance"
            class="text-center"
          >
            <span :style="getColor(perfomanceAux)">{{ ticketMedioPerformance }}</span><br>
            de perfomance
          </div>
          <div
            class="text-center"
          >
            <dashboard-evolucao-ticket-cliente />
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../../services/somentecliente'
  import eventEmit from '../../../core/EventoEmit'

  export default {
    name: 'ShowExtratoClientesFaturados',
    emits: ['setDadosTicketMedioCliente'],
    components: {
      DashboardEvolucaoTicketCliente: () => import('../../../../graficos/SomenteClientes/ExtratoCliente/ClientesEvolucaoTicketCliente'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      selectCliente: JSON.parse(localStorage.clienteSelect),
      vendedores: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      exibirTicket: false,
      ticketMedio: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      perfomanceAux: 0,
      quantidadeVendas: 0,
      ticketMedioPerformance: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    }),

    created () {
      eventEmit.$on('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select, selectCliente, vendedores, area, rede, supervisor, receita, segmento, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.select = select
        this.selectCliente = selectCliente
        this.vendedores = vendedores
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.showDadosTicketMedio()
      },

      async showDadosTicketMedio () {
        this.loading = true
        this.exibirTicket = false

        this.ticketMedio = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.quantidadeVendas = 0
        this.ticketMedioPerformance = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.perfomanceAux = 0

        eventEmit.$emit('set-dados-ticket-medio-cliente', [], [])

        await Clientes.showTicketMedioClientes(this.primeiroDia, this.ultimoDia, this.select, this.selectCliente, this.vendedores, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.ticketMedio = resposta.data.ticketMedio.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.quantidadeVendas = resposta.data.vendas

            this.ticketMedioPerformance = resposta.data.perfomance.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.perfomanceAux = resposta.data.perfomance

            eventEmit.$emit('set-dados-ticket-medio-cliente', resposta.data.dadosTicketMedio, resposta.data.labels)
          } else if (resposta.data.msg === 'Não há faturamento para o(s) cliente(s) selecionado') {
            this.ticketMedio = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.quantidadeVendas = 0

            this.ticketMedioPerformance = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.perfomanceAux = 0

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Data Final não pode ser mair que a data inicial') {
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.exibirTicket = true
        })
      },

      getColor (value) {
        if (value < 0) {
          return 'color: red; font-weight: bold'
        } else {
          return 'color: #2863af; font-weight: bold'
        }
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
